// extracted by css-extract-rspack-plugin
export default {"TabList":"SpecificDatePicker-module__TabList___vD_lq"};